import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import AttractionPage from './AttractionPage';
import BusStopPage from './BusStopPage';
import LineSetPage from './LineSetPage';
import VehiclePage from './VehiclePage';

const BusTourPage = (props) => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/line-sets`}>
                <LineSetPage {...props} />
            </Route>
            <Route path={`${path}/vehicles`}>
                <VehiclePage {...props} />
            </Route>
            <Route path={`${path}/attractions`}>
                <AttractionPage {...props} />
            </Route>
            <Route path={`${path}/bus-stops`}>
                <BusStopPage {...props} />
            </Route>
        </Switch>
    );
};

export default BusTourPage;
